import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#E30714",
      primaryHover: "#a80000",
    },
    logoImage: logo,
    backend: "https://kataloge.schaffrath.com/",
    directory: "/kiosk",
    header: {
      title: "Schaffrath",
      metaTitle: "Aktuelle Schaffrath Prospekte & Angebote",
      lineHeader: true,
      link: 'https://www.schaffrath.com/'
    },
    accToolbar: false,
    tracking: {
      type: 'GTM',
      id: 'GTM-WTFX5FF',
      cookieConsent: {
        type: 'GTM'
      }
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.schaffrath.com/impressum.html'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.schaffrath.com/datenschutz.html'
    },
  ],
  };